'use strict';

/**
 * Webduct Oauth2Http (WebductOauth2Http.js).
 * Webduct Oauth2Http Helper.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2018-2020 Build Centrix.
 *
 * @version
 * 1.15.0 LIBENV-53 Add WebductOauth2Http into globalThis for ES6 usage
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */

var WebductOauth2Http = function(cookieAdapter, WebductApiResponseHandler) {

    var self = this;

    /**
     * OAuth2 Client
     *
     * This object is returned.
     *
     * @since 1.0.0
     *
     * @type {Object}
     */
    var client = {};

    /**
     * @since 1.0.0
     *
     * @type {String}
     */
    var oauth2InfoKey = 'oauth2_info';

    /**
     * @since 1.0.0
     *
     * @type {String}
     */
    var wdSettingsKey = 'wd.settings';

    /**
     * @since 1.0.0
     *
     * @type {Object}
     */
    self.cookieOptions = {};

    /**
     * Get access_token
     *
     * @since 1.0.0
     *
     * @returns {Promise}
     */
    client.getAccessToken = function () {

        var result;
        var response;

        response = client.getOauth2Info();

        try {
            response = JSON.parse(response);
        } catch (exception) {
            response = {
                statusText: 'error: invalid response of [' + response + ']'
            };
        }

        result = response['access_token'];

        return result;
    };

    /**
     * Get deployment token
     *
     * @since 1.0.0
     *
     * @returns {Promise}
     */
    client.getDeploymentToken = function () {

        var result;
        var response;

        response = client.getOauth2Info();

        try {
            response = JSON.parse(response);
        } catch (exception) {
            response = {
                statusText: 'error: invalid response of [' + response + ']'
            };
        }

        result = response.deployment_tokens;

        return result;
    };

    /**
     * Get OAuth2 info
     *
     * @since 1.0.0
     * @returns {String}
     */
    client.getOauth2Info = function () {
        var result;

        result = cookieAdapter.getCookie(oauth2InfoKey);

        return result;
    };

    /**
     * Get wdSettings info
     *
     * @since 1.0.0
     * @returns {String}
     */
    client.getWdSettingsInfo = function () {
        var result;

        result = cookieAdapter.getCookie(wdSettingsKey);

        return result;
    };


    /**
     * Set OAuth2 info
     *
     * @since 1.0.0
     *
     * @param value
     * @returns {Boolean}
     */
    client.setOauth2Info = function (value) {
        var result;
        var cookieDomain = '';
        var expireOptions = {};

        if (typeof self.cookieOptions.domain !== 'undefined') {
            cookieDomain = self.cookieOptions.domain;
        }

        // Check if the oauth2 cookie domain is not the webduct.com domain
        // If so, then we need to delete the oauth2 cookie for the webduct.com domain to avoid conflicts
        if (cookieDomain !== 'webduct.com') {
            expireOptions = {
                path: '/',
                domain: 'webduct.com'
            };

            cookieAdapter.expireCookie(oauth2InfoKey, expireOptions);
        }

        // Expire the existing cookie for the domain
        expireOptions = {
            path: '/',
            domain: cookieDomain
        };

        cookieAdapter.expireCookie(oauth2InfoKey, expireOptions);

        var options = {
            path: '/',
            domain: cookieDomain,
            expires: '',
            secure: false
        };

        cookieAdapter.setOptions(options.path, options.domain, options.expires, options.secure);
        result = cookieAdapter.setCookie(oauth2InfoKey, value);

        return result;
    };

    /**
     * Check if response is good
     *
     * @since 1.0.0
     *
     * @param {Object} response
     * @returns {Boolean} Checks if is good (status code: 2000) and returns true, otherwise returns false
     */
    client.isGoodResponse = function (response) {

        var result;
        var responseCode = response.status;

        result = WebductApiResponseHandler.isGoodResponseCode(responseCode);

        return result;
    };

    /**
     * Get the refresh token from storage (cookie)
     *
     * @since 1.0.0
     *
     * @returns {String} Returns the refresh token
     */
    client.getRefreshToken = function () {

        var result = '';
        var cookieResult = cookieAdapter.getCookie(oauth2InfoKey);

        if (typeof cookieResult !== 'undefined') {

            var oauth2Info = JSON.parse(cookieResult);

            if (typeof oauth2Info.refresh_token !== 'undefined') {

                result = oauth2Info.refresh_token;

            }
        }

        return result;
    };

    /**
     * Set the oauth2 cookie options
     *
     * @since 1.0.0
     *
     * @param {Object} options
     */
    client.setOauth2CookieOptions = function(options) {
        self.cookieOptions = options;
    };

    return client;

};
globalThis.WebductOauth2Http = WebductOauth2Http;
// EOF